'use client';
import React from 'react';
import Image from 'next/image';
import { useState } from 'react';

const OdooServies = () => {
    const [switch1, setSwitch1] = useState(false);

    return (
        <div className="section-py bg-grey dark:bg-black odd-with-position">
            {/* Show the image by default and hide it when switch1 is true */}
            {!switch1 && (
                <div className="odd-without-position">
                    <Image
                        alt="apps switched"
                        src="/img/odoo/apps_switched.svg"
                        height="729"
                        width="1250"
                        className="img-fluid"
                        loading="lazy"
                    />
                </div>
            )}
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-16">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Odoo
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Centralize operations with our platform: simple, efficient, affordable for all!
                        </h2>
                        <div className="row grid lg:grid-cols-12 pt-[50px] pb-[80px]">
                            <div className="lg:col-span-8 lg:col-start-3">
                                <div className="corner-heighlight">
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            defaultValue=""
                                            className="sr-only peer"
                                            checked={switch1}
                                            onChange={(e) => setSwitch1(e.target.checked)}
                                        />
                                        <div className="relative w-12 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[3px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" />
                                        <span className="ms-3 fs-md fw-700 text-purple">
                                            Imagine with Odoo Single Subscription.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 pb-50">
                    <div className="lg:col-span-8 lg:col-start-3">
                        <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-3 odoo-service-row">
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Accounting icon"
                                            src="/img/odoo/accounting.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Accounting</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo knowledge icon"
                                            src="/img/odoo/knowledge.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Knowledge</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo sign icon"
                                            src="/img/odoo/sign.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Sign</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo crm icon"
                                            src="/img/odoo/crm.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">CRM</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo studio icon"
                                            src="/img/odoo/studio.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Studio</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo subscriptions icon"
                                            src="/img/odoo/subscriptions.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Subscriptions</figcaption>
                                    </figure>
                                </a>
                            </div>
                        </div>
                        <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-3 odoo-service-row">
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Rental icon"
                                            src="/img/odoo/rental.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Rental</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Point of Sale icon"
                                            src="/img/odoo/point_of_sale.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Point of Sale</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Discuss icon"
                                            src="/img/odoo/discuss.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Discuss</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Documents icon"
                                            src="/img/odoo/documents.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Documents</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Project icon"
                                            src="/img/odoo/project.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Project</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Timesheets icon"
                                            src="/img/odoo/timesheet.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Timesheets</figcaption>
                                    </figure>
                                </a>
                            </div>
                        </div>
                        <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-3 odoo-service-row">
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Field Service icon"
                                            src="/img/odoo/field_service.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Field Service</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Planning icon"
                                            src="/img/odoo/planning.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Planning</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Helpdesk icon"
                                            src="/img/odoo/helpdesk.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Helpdesk</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Website icon"
                                            src="/img/odoo/website.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Website</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Social Marketing icon"
                                            src="/img/odoo/social_marketing.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Social Marketing</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Email Marketing icon"
                                            src="/img/odoo/email_marketing.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Email Marketing</figcaption>
                                    </figure>
                                </a>
                            </div>
                        </div>
                        <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-3 odoo-service-row">
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Purchase icon"
                                            src="/img/odoo/purchase.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Purchase</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Inventory icon"
                                            src="/img/odoo/inventory.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Inventory</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Manufacturing icon"
                                            src="/img/odoo/manufacturing.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Manufacturing</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Sales icon"
                                            src="/img/odoo/sales.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Sales</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo hr icon"
                                            src="/img/odoo/hr.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">HR</figcaption>
                                    </figure>
                                </a>
                            </div>
                            <div className="text-center odoo-service mb-30">
                                <a href="javascript:void(0)">
                                    <figure>
                                        <Image
                                            alt="Odoo Dashboard icon"
                                            src="/img/odoo/dashboard.svg"
                                            height="80"
                                            width="80"
                                            className="img-thumbnail mb-3"
                                            loading="lazy"
                                        />
                                        <figcaption className="fw-600">Dashboard</figcaption>
                                    </figure>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OdooServies;
